import { lazy, Suspense } from "react";
import { ErrorBoundary } from "../components/ErrorBoundary";

const ActivityLog = lazy(
  () => import("../modules/upload-inbox/components/ActivityLog")
);

export function ActivityPage() {
  return (
    <ErrorBoundary fallback={<div style={{ padding: 24 }}>Activity Log failed to load.</div>}>
      <Suspense fallback={<div className="remote-loading"><p>Loading Activity Log...</p></div>}>
        <ActivityLog />
      </Suspense>
    </ErrorBoundary>
  );
}
